import { useNavigate } from "react-router-dom";

export default function Error() {
  const navigate = useNavigate();

  return (
    <div className="min-vh-100 d-flex flex-column justify-content-center align-items-center bg-dark text-white">


      {/* Image placeholder */}
      <div
        className="mb-4 d-flex justify-content-center"
        style={{ width: "100%", maxWidth: "500px" }}
      >
        <img
          src="../images/error_cat.png"   // ⬅️ TI ĆEŠ OVDE UBACITI SVOJ PNG
          alt="Debugging robot"
          style={{
            width: "100%",
            maxWidth: "500px",
            height: "auto",
            opacity: 0.9,
          }}
        />
      </div>

      <h1 className="display-4 fw-bold text-danger">Oops!</h1>
      <p className="text-white-50 mb-4">
        Došlo je do greške ili nemate dozvolu za pristup.
      </p>

      <div className="d-flex gap-3">
        <button
          className="btn btn-primary"
          onClick={() => navigate("/login")}
        >
          Go to Login
        </button>

        <button
          className="btn btn-outline-light"
          onClick={() => navigate("/")}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}